import { registerBlockType } from "@wordpress/blocks";
import config, { BlockAttributes } from "./block.json";
import "../slider/swiper";
import NewsEditor from "./NewsEditor";
import NewsSave from "./NewsSave";

registerBlockType<BlockAttributes>(config.name, {
  ...config,
  edit: NewsEditor,
  save: NewsSave,
});
